export class ComparisonConfig {
  rewrite: boolean;
  pageSelector: boolean;
  download: boolean;
  upload: boolean;
  print: boolean;
  browse: boolean;
  enableRightClick: boolean;

  filesDirectory: string;
  fontsDirectory: string;
  defaultDocument: string;
  preloadResultPageCount: 0;
}
